// src/components/progress-bar.ts
import { html, type TemplateResult } from 'lit-html';

interface ProgressBarParams {
  total: number;
  current: number;
  answered: number[];
}

export function renderProgressBar({ total, current, answered }: ProgressBarParams): TemplateResult {
  const answeredSet = new Set(answered);
  return html`
    <div class="progress-bar">
      <div class="progress-meta">${answered.length} / ${total}</div>
      <div class="progress-dots">
        ${Array.from({ length: total }, (_, i) => {
          const isAnswered = answeredSet.has(i);
          const isCurrent = i === current;
          const cls = ['pdot',
            isAnswered ? 'pdot-answered' : '',
            isCurrent ? 'pdot-current' : ''
          ].filter(Boolean).join(' ');
          return html`<button class=${cls} data-idx=${i} aria-label=${`第 ${i + 1} 题`}>${i + 1}</button>`;
        })}
      </div>
    </div>
  `;
}

export function bindProgressBar(root: HTMLElement, onJump: (idx: number) => void): void {
  root.querySelectorAll<HTMLButtonElement>('.pdot.pdot-answered').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.idx;
      if (idx !== undefined) onJump(Number(idx));
    });
  });
}
